import React from 'react';
import ServiceUnderConstruction from '../../components/ServiceUnderConstruction';
import logo from '../../assets/images/services/kolaboexpress.webp';

const KolaboExpress = () => {
    return (
        <ServiceUnderConstruction
            serviceKey="kolaboExpress"
            logo={logo}
            primaryColor="#E74C3C"
            secondaryColor="#C0392B"
        />
    );
};

export default KolaboExpress;
